import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    deleteFailed: (assetCount: number) => string;
    deleteDenied: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            deleteFailed: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (assetCount: number): string => __intl__.intl().formatMessage({ id: "useBulkDeleteAssets.deleteFailed?c=228u5d2610pjh", defaultMessage: "Failed to delete {assetCount} items" }, { assetCount: assetCount }));
                },
                enumerable: true,
                configurable: true
            },
            deleteDenied: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useBulkDeleteAssets.deleteDenied?c=36o1qtam5nker", defaultMessage: "You don''t have permission to delete these items." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
